export function addStyleToLinks(htmlString: string): string {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, "text/html")

  const links = doc.querySelectorAll("a")

  links.forEach((link) => {
    const existingStyle = link.getAttribute("style") || ""

    const newStyle = `${existingStyle}; max-width: 100%; display: block; overflow: hidden; text-overflow: ellipsis;`

    link.setAttribute("style", newStyle)
  })

  return doc.body.innerHTML
}
